import React, { useEffect, useState, useRef, createElement, Component } from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { WaterTribeFestTicketSelection } from '../components/WaterTribeFestTicketSelection';
import { WaterTribeFestPrePaymentForm } from '../components/WaterTribeFestPrePaymentForm';
import { UtmCapture } from '../components/UtmCapture';
import { motion, AnimatePresence } from 'framer-motion';
import { Waves, Heart, GraduationCap, Target, Sparkles, Music, Zap, Users, Calendar, MapPin, CheckCircle2, Flame, MessageCircle, CreditCard, Lock, X } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { generateOrderNumber } from '../utils/orderNumber';
import { openTranzilaPayment } from '../utils/tranzila';
import { getUtmParams } from '../utils/utmTracking';
const activities = [{
  icon: Waves,
  title: 'חתירות חוויתיות ותחרותיות',
  description: 'מקצים עממיים ותחרותיים לכל הרמות בסאפ, רייס, קיאק וסרפסקי.',
  image: 'https://cdn.magicpatterns.com/uploads/81TuRkRozsSneXuE9PPvfp/IMG-20250201-WA0062.jpg'
}, {
  icon: Heart,
  title: 'חוויות גוף-נפש',
  description: 'יוגה, פילאטיס מחזק ואמבטיית קרח מודרכת להתאוששות',
  image: 'https://cdn.magicpatterns.com/uploads/oRhKrcQ2puhfgDX5hZr1xf/IMG-20250513-WA0010.jpg'
}, {
  icon: GraduationCap,
  title: 'סדנאות חתירה',
  description: 'שיפור טכניקה, הרצאות והדרכות עם המאמנים המובילים בארץ',
  image: 'https://cdn.magicpatterns.com/uploads/o9c53mVsS3VW85WhRtdH5V/IMG-20251017-WA0049.jpg'
}, {
  icon: Target,
  title: 'תכני העשרה',
  description: 'הרצאות השראה, סדנאות ועוד מלא הפתעות',
  image: 'https://cdn.magicpatterns.com/uploads/jv9JCKZ7rbuxPY1UBjZSNt/IMG-20251007-WA0003.jpg'
}, {
  icon: Music,
  title: 'מוזיקה ואווירת חוף',
  description: 'וחה מסיבת שקיעה, בירה קרה ואנשים טובים.',
  image: 'https://cdn.magicpatterns.com/uploads/ogPVnt7wGEJk1JMJE6qQr3/IMG-20250919-WA0024.jpg'
}, {
  icon: Users,
  title: 'מפגש קהילתי',
  description: 'כל קהילת המים של ישראל במקום אחד - הזדמנות להכיר ולהתחבר',
  image: 'https://cdn.magicpatterns.com/uploads/jthr15SsJsNm2nReM2yG6L/IMG-20250201-WA0077.jpg'
}, {
  icon: Sparkles,
  title: 'התנסות בציוד חדשני',
  description: 'הזדמנות לנסות את הציוד המתקדם ביותר עם המותגים המובילים בארץ ובעולם',
  image: 'https://cdn.magicpatterns.com/uploads/7Nsyyb3XcL22vTisSrbp26/file_00000000c840720c8d220c7d5f9e2f7f_(1).png'
}];
const audience = ['חותרות וחותרים, אוהבי ספורט וספורט ימי בכל הרמות', 'חותרים מקצועיים שרוצים להתחרות ולהשתפר', 'מתחילים שרוצים לנסות לראשונה ולהתאהב בים', 'חובבי תנועה, בריאות ולייף-סטייל', 'חובבי ים שרוצים חוויה של חופש', 'כל מי שמחפש חוויה ייחודית, מהנה וקהילתית במים וביבשה'];
const reasons = [{
  title: 'האירוע היחיד מסוגו',
  description: 'שילוב נדיר של מקצועיות, חוויה וקהילה ביום אחד מרוכז'
}, {
  title: 'ציוד בלעדי',
  description: 'הזדמנות לנסות כלים וציוד שלא נגישים ביום-יום'
}, {
  title: 'האנשים הנכונים',
  description: 'לפגוש את המדריכים והחותרים שהופכים את עולם המים למה שהוא'
}, {
  title: 'לוקיישן מושלם',
  description: 'חוף מעגן עדן - רצועת החוף היפה והאקסקלוסיבית ביותר בכנרת'
}];
export function WaterTribeFestPage() {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [showPrePaymentForm, setShowPrePaymentForm] = useState(false);
  const [selectedTicketName, setSelectedTicketName] = useState('');
  const [showIframe, setShowIframe] = useState(false);
  const [includeCompanion, setIncludeCompanion] = useState(false);
  const [showShimmer, setShowShimmer] = useState(false);
  const [showNotice, setShowNotice] = useState(true);
  const [pendingTicket, setPendingTicket] = useState<{
    price: number;
    name: string;
    priceDisplay: string;
    ticketType?: 'festival-only' | 'accommodation' | 'double-alone';
  } | null>(null);
  // ============================================
  // TEST MODE - DELETE THIS SECTION TO REMOVE
  // ============================================
  const [isTestMode, setIsTestMode] = useState(false);
  // ============================================
  const iframeRef = useRef<HTMLIFrameElement>(null);
  useEffect(() => {
    ;
    (window as any).openWaterTribeFestRegistrationForm = () => setIsFormOpen(true);
    // ============================================
    // TEST MODE - DELETE THIS BLOCK TO REMOVE
    // ============================================
    // Check for test mode URL parameter
    const urlParams = new URLSearchParams(window.location.search);
    const testModeParam = urlParams.get('test_mode');
    if (testModeParam === 'watertribe2026') {
      setIsTestMode(true);
      localStorage.setItem('test_mode_active', 'true');
      console.log('🧪 TEST MODE ACTIVATED - All prices set to ₪1');
    } else {
      // Check localStorage in case we navigated away and back
      const storedTestMode = localStorage.getItem('test_mode_active');
      if (storedTestMode === 'true') {
        setIsTestMode(true);
        console.log('🧪 TEST MODE ACTIVE (from localStorage)');
      }
    }
    // ============================================
    // Trigger shimmer animation after 0.5 seconds
    const shimmerTimer = setTimeout(() => {
      setShowShimmer(true);
      // Remove shimmer after 1.5 seconds
      setTimeout(() => setShowShimmer(false), 1500);
    }, 500);
    document.title = 'Water Tribe Fest 2026 - פסטיבל החתירה של ישראל';
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', 'פסטיבל החתירה השנתי בכנרת. סאפ, קיאקים, יוגה, סדנאות, הופעות וקהילה.');
    const ogTags = [{
      property: 'og:title',
      content: 'Water Tribe Fest 2026 - פסטיבל החתירה של ישראל'
    }, {
      property: 'og:description',
      content: '9-11 באפריל 2026 | חוף מעגן עדן, כנרת.'
    }, {
      property: 'og:type',
      content: 'website'
    }, {
      property: 'og:image',
      content: 'https://cdn.magicpatterns.com/uploads/81TuRkRozsSneXuE9PPvfp/IMG-20250201-WA0062.jpg'
    }, {
      property: 'og:url',
      content: window.location.href
    }];
    ogTags.forEach(tag => {
      let metaTag = document.querySelector(`meta[property="${tag.property}"]`);
      if (!metaTag) {
        metaTag = document.createElement('meta');
        metaTag.setAttribute('property', tag.property);
        document.head.appendChild(metaTag);
      }
      metaTag.setAttribute('content', tag.content);
    });
  }, []);
  const handleCompanionOnlyPurchase = () => {
    // Direct purchase of companion ticket only - set ticket type to festival-only
    // ============================================
    // TEST MODE - DELETE THIS BLOCK TO REMOVE
    // ============================================
    const finalPrice = isTestMode ? 1 : 255;
    const finalPriceDisplay = isTestMode ? '1' : '255';
    // ============================================
    const companionTicket = {
      price: finalPrice,
      name: 'כרטיס מלווה בלבד',
      priceDisplay: finalPriceDisplay,
      ticketType: 'festival-only' as const
    };
    setSelectedTicketName(companionTicket.name);
    setPendingTicket(companionTicket);
    setShowPrePaymentForm(true);
    // Track Meta Pixel event
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: companionTicket.name,
        content_category: 'Festival Ticket',
        value: companionTicket.price,
        currency: 'ILS'
      });
    }
  };
  const handleTicketSelect = (price: number, name: string, priceDisplay: string) => {
    // Store ticket info and open pre-payment form
    // Determine ticket type based on name
    let ticketType: 'festival-only' | 'accommodation' | 'double-alone' = 'accommodation';
    if (name.includes('פסטיבל בלבד')) {
      ticketType = 'festival-only';
    } else if (name.includes('חדר זוגי לבד')) {
      ticketType = 'double-alone';
    }
    // ============================================
    // TEST MODE - DELETE THIS BLOCK TO REMOVE
    // ============================================
    const finalPrice = isTestMode ? 1 : price;
    const finalPriceDisplay = isTestMode ? '1' : priceDisplay;
    // ============================================
    setSelectedTicketName(name);
    setPendingTicket({
      price: finalPrice,
      name,
      priceDisplay: finalPriceDisplay,
      ticketType
    });
    setShowPrePaymentForm(true);
    // Track Meta Pixel event - Ticket Selected
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: name,
        content_category: 'Festival Ticket',
        value: finalPrice,
        currency: 'ILS'
      });
    }
  };
  const handlePrePaymentFormSubmit = async (formData: any) => {
    // Generate unique order number
    const orderNumber = generateOrderNumber();
    // CRITICAL: Capture UTM params NOW, at form submission time
    // This ensures they're stored with the registration data
    // and won't be lost if localStorage is cleared during payment
    const utmParams = getUtmParams();
    console.log('📊 Capturing UTM params at form submission:', utmParams);
    // Map form data to proper format
    const submissionData = {
      name: formData.fullName,
      phone: formData.phone,
      email: formData.email,
      orderNumber: orderNumber,
      ticketType: pendingTicket?.name || '',
      price: pendingTicket?.priceDisplay || '',
      gender: formData.gender === 'male' ? 'זכר' : formData.gender === 'female' ? 'נקבה' : '',
      companionName: formData.companionName || '',
      companionPhone: formData.companionPhone || '',
      companionGender: formData.companionGender === 'male' ? 'זכר' : formData.companionGender === 'female' ? 'נקבה' : '',
      nightChoice: formData.nightChoice === 'thursday' ? 'חמישי' : formData.nightChoice === 'friday' ? 'שישי' : '',
      roomType: formData.roomType === 'double' ? 'זוגי' : formData.roomType === 'triple' ? 'טריפל' : '',
      roommate1: formData.roommate1Name || '',
      roommate2: formData.roommate2Name || '',
      competitiveTrack: formData.competitiveTrack && formData.competitiveTrack.length > 0 ? formData.competitiveTrack.map((t: string) => {
        if (t === 'no') return 'לא';
        if (t === 'sprint') return 'ספרינט';
        if (t === 'technical') return 'טכני';
        if (t === 'longDistance') return 'לונג דיסטנס';
        return t;
      }).join(', ') : 'לא',
      rowingType: formData.rowingType === 'sup' ? 'סאפ' : formData.rowingType === 'race' ? 'רייס' : formData.rowingType === 'surfski' ? 'סרפסקי' : formData.rowingType === 'surfer' ? 'גולש' : formData.rowingType === 'atmosphere' ? 'סופג אווירה' : '',
      clubName: formData.belongsToClub === 'yes' && formData.clubName ? formData.clubName : 'לא שייך למועדון',
      rentBoard: formData.rentBoard === 'yes' ? 'כן' : formData.rentBoard === 'no' ? 'לא' : '',
      whatsappGroup: formData.whatsappGroup ? 'כן' : 'לא',
      type: 'הרשמה Water Tribe Fest',
      source: 'טופס תשלום',
      // CRITICAL: Include UTM params directly in registration data
      // This ensures they survive localStorage clearing in Meta in-app browsers
      utm_source: utmParams.utm_source,
      utm_medium: utmParams.utm_medium,
      utm_campaign: utmParams.utm_campaign,
      utm_content: utmParams.utm_content,
      utm_term: utmParams.utm_term,
      utm_id: utmParams.utm_id,
      fbclid: utmParams.fbclid
    };
    // Store order details in localStorage for thank you page
    localStorage.setItem('pendingOrder', JSON.stringify({
      orderNumber: orderNumber,
      name: formData.fullName,
      email: formData.email,
      timestamp: Date.now()
    }));
    // Store registration data for Make.com webhook (sent after payment success)
    localStorage.setItem('pendingRegistrationData', JSON.stringify(submissionData));
    console.log('📦 Registration data stored, waiting for payment...');
    // Close the form
    setShowPrePaymentForm(false);
    // Track Meta Pixel event - Initiate Checkout
    if (window.fbq && pendingTicket) {
      window.fbq('track', 'InitiateCheckout', {
        content_name: pendingTicket.name,
        content_category: 'Festival Ticket',
        value: pendingTicket.price,
        currency: 'ILS',
        num_items: 1
      });
    }
    // Show iframe container
    setShowIframe(true);
    // Open Tranzila payment using the utility function
    if (pendingTicket) {
      // Small delay to ensure iframe is rendered
      setTimeout(() => {
        openTranzilaPayment({
          sum: pendingTicket.price,
          contact: formData.fullName,
          email: formData.email,
          phone: formData.phone,
          pdesc: `Water Tribe Fest 2026 - ${pendingTicket.name}`,
          success_url: `${window.location.origin}/tranzila-success`,
          fail_url: `${window.location.origin}/water-tribe-fest`,
          u1: orderNumber,
          u2: pendingTicket.name,
          u3: pendingTicket.priceDisplay
        });
        // Scroll to iframe after submission
        setTimeout(() => {
          iframeRef.current?.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }, 100);
      }, 100);
    }
  };
  return <div className="min-h-screen bg-white" dir="rtl" data-id="element-1556">
      <UtmCapture data-id="element-1557" />
      <Navigation data-id="element-1558" />

      {/* Security Notice Popup */}
      <AnimatePresence data-id="element-1559">
        {showNotice && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{
        backgroundColor: 'rgba(0,0,0,0.55)',
        backdropFilter: 'blur(4px)'
      }} onClick={() => setShowNotice(false)} data-id="element-1560">
            <motion.div initial={{
          opacity: 0,
          scale: 0.9,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 10
        }} transition={{
          type: 'spring',
          damping: 20,
          stiffness: 300
        }} onClick={e => e.stopPropagation()} className="relative bg-white rounded-3xl shadow-2xl max-w-md w-full p-8 text-center" data-id="element-1561">
              {/* Close button */}
              <button onClick={() => setShowNotice(false)} className="absolute top-4 left-4 text-gray-400 hover:text-gray-600 transition-colors p-1 rounded-full hover:bg-gray-100" data-id="element-1562">
                <X className="w-5 h-5" data-id="element-1563" />
              </button>

              {/* Icon */}
              <div className="text-5xl mb-4" data-id="element-1564">🔄</div>

              {/* Content */}
              <h2 className="text-2xl font-black text-gray-900 mb-5 leading-snug" data-id="element-1565">
                עדכון חשוב — תאריכים חדשים! 🎉
              </h2>
              <div className="space-y-3 text-gray-700 text-lg leading-relaxed" data-id="element-1566">
                <p className="font-medium" data-id="element-1567">הפסטיבל שודרג לתאריכים חדשים:</p>
                <p className="text-2xl font-black text-[#0A5F8F]" data-id="element-1568">
                  9-11 באפריל 2026
                </p>
                <p className="text-base text-gray-600" data-id="element-1569">
                  שיא העונה בכנרת — מזג אוויר מושלם, מים חמים יותר וחוויה
                  משודרגת!
                </p>
              </div>

              {/* CTA */}
              <button onClick={() => setShowNotice(false)} className="mt-7 w-full bg-gradient-to-r from-[#0A5F8F] to-cyan-500 text-white font-bold py-3 px-6 rounded-2xl hover:opacity-90 transition-opacity" data-id="element-1570">
                מעולה, בואו נמשיך! 🌊
              </button>
            </motion.div>
          </motion.div>}
      </AnimatePresence>

      {/* ============================================ */}
      {/* TEST MODE INDICATOR - DELETE THIS TO REMOVE */}
      {/* ============================================ */}
      {isTestMode && <div className="fixed top-4 left-4 z-50 bg-yellow-500 text-black px-4 py-2 rounded-lg shadow-lg font-bold text-sm flex items-center gap-2" data-id="element-1571">
          <Zap className="w-4 h-4" data-id="element-1572" />
          TEST MODE - ₪1
        </div>}
      {/* ============================================ */}

      {/* Hero */}
      <div className="relative h-screen min-h-[600px] overflow-hidden flex items-center justify-center" data-id="element-1573">
        <div className="absolute inset-0 bg-gradient-to-b from-blue-900/40 via-blue-800/20 to-[#0A5F8F]/90 z-10" data-id="element-1574" />
        <video autoPlay muted loop playsInline className="absolute inset-0 w-full h-full object-cover" data-id="element-1575">
          <source src="https://cdn.magicpatterns.com/uploads/bHRRxzcgoWuLZVsSMLwyGt/VID-20251224-WA0026.undefined" type="video/mp4" data-id="element-1576" />
        </video>
        <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-white to-transparent z-20" data-id="element-1577" />

        <div className="relative z-30 container mx-auto px-4 text-center text-white" data-id="element-1578">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} data-id="element-1579">
            <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-md px-4 py-2 rounded-full mb-6 border border-white/30" data-id="element-1580">
              <Calendar className="w-5 h-5" data-id="element-1581" />
              <span className="font-medium" data-id="element-1582">9-11 באפריל 2026</span>
              <span className="mx-2" data-id="element-1583">|</span>
              <MapPin className="w-5 h-5" data-id="element-1584" />
              <span data-id="element-1585">חוף מעגן עדן, כנרת</span>
            </div>

            <h1 className="text-6xl md:text-8xl font-black mb-4 tracking-tight drop-shadow-lg" data-id="element-1586">
              <span className="block text-transparent bg-clip-text bg-gradient-to-r from-cyan-300 to-white" data-id="element-1587">
                WATER TRIBE
              </span>
              <span className="block mt-2" data-id="element-1588">FEST 2026</span>
            </h1>

            <p className="text-2xl md:text-4xl font-light mb-12 text-blue-100 max-w-3xl mx-auto" data-id="element-1589">
              פסטיבל החתירה השנתי של ישראל
            </p>

            <motion.div initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            delay: 0.5
          }} className="text-center" data-id="element-1590">
              <div className="text-white text-xl md:text-2xl font-light mb-3" data-id="element-1591">
                לכל הפרטים המשיכו לגלול
              </div>
              <motion.div animate={{
              y: [0, 12, 0]
            }} transition={{
              duration: 2,
              repeat: Infinity,
              ease: 'easeInOut'
            }} className="text-white text-4xl" data-id="element-1592">
                ↓
              </motion.div>
            </motion.div>
          </motion.div>
        </div>
      </div>

      {/* Story */}
      <section className="py-12 bg-white" data-id="element-1593">
        <div className="container mx-auto px-4" data-id="element-1594">
          <div className="max-w-4xl mx-auto text-center" data-id="element-1595">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-4xl md:text-6xl font-bold text-[#0A5F8F] mb-8" data-id="element-1596">
              זה לא עוד אירוע ספורט
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="text-xl md:text-2xl text-gray-600 leading-relaxed" data-id="element-1597">
              זה סופשבוע אחד שמאחד את כל תרבות החתירה בישראל:
              <br data-id="element-1598" />
              <span className="font-bold text-gray-900" data-id="element-1599">
                מים, קהילה, חוויה וגופנפש.
              </span>
            </motion.p>
          </div>
        </div>
      </section>

      {/* Activities */}
      <section className="py-16 bg-gray-50" data-id="element-1600">
        <div className="container mx-auto px-4" data-id="element-1601">
          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} className="text-center mb-16" data-id="element-1602">
            <h2 className="text-4xl md:text-5xl font-bold text-[#0A5F8F] mb-4" data-id="element-1603">
              מה מחכה לכם בפסטיבל?
            </h2>
            <p className="text-xl text-gray-600" data-id="element-1604">
              הפסטיבל שמאגד את כל מה שאתם אוהבים בים - בסופשבוע אחד
            </p>
          </motion.div>

          <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-1605">
            {activities.map((activity, index) => <motion.div key={index} initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className={`rounded-3xl shadow-lg hover:shadow-xl transition-all border border-gray-100 overflow-hidden h-full min-h-[300px] relative ${index === activities.length - 1 ? 'col-span-2 md:col-span-2 lg:col-span-1 lg:col-start-2' : ''}`} data-id="element-1606">
                <div className="absolute inset-0" data-id="element-1607">
                  <img src={activity.image} alt={activity.title} className={`w-full h-full object-cover ${activity.imagePosition || 'object-center'}`} data-id="element-1608" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent" data-id="element-1609" />
                </div>
                <div className="relative z-10 p-8 h-full flex flex-col justify-end" data-id="element-1610">
                  <h3 className="text-xl font-bold text-white mb-2" data-id="element-1611">
                    {activity.title}
                  </h3>
                  <p className="text-gray-200 text-sm leading-relaxed" data-id="element-1612">
                    {activity.description}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Who Should Come */}
      <section className="py-24 bg-[#0A5F8F] text-white relative overflow-hidden" data-id="element-1613">
        <div className="absolute top-0 right-0 w-96 h-96 bg-white/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-1614" />
        <div className="absolute bottom-0 left-0 w-64 h-64 bg-cyan-400/10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" data-id="element-1615" />

        <div className="container mx-auto px-4 relative z-10" data-id="element-1616">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-1617">
            <motion.div initial={{
            opacity: 0,
            x: 50
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} data-id="element-1618">
              <h2 className="text-5xl md:text-6xl font-bold mb-8 leading-tight" data-id="element-1619">
                למי הפסטיבל
                <br data-id="element-1620" />
                <span className="text-cyan-300" data-id="element-1621">מתאים?</span>
              </h2>
              <p className="text-xl text-blue-100 mb-8 max-w-md" data-id="element-1622">
                בין אם אתם חותרים מקצועיים או שמעולם לא עליתם על סאפ - הפסטיבל
                הזה הוא בשבילכם.
              </p>
            </motion.div>

            <div className="space-y-4" data-id="element-1623">
              {audience.map((item, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: -30
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1
            }} className="flex items-center gap-4 bg-white/10 backdrop-blur-sm p-4 rounded-xl border border-white/10" data-id="element-1624">
                  <div className="bg-cyan-400 rounded-full p-1 shrink-0" data-id="element-1625">
                    <CheckCircle2 className="w-5 h-5 text-[#0A5F8F]" data-id="element-1626" />
                  </div>
                  <span className="text-lg font-medium" data-id="element-1627">{item}</span>
                </motion.div>)}
            </div>
          </div>
        </div>
      </section>

      {/* Why Miss (FOMO) */}
      <section className="py-24 bg-gradient-to-br from-orange-50 to-rose-50" data-id="element-1628">
        <div className="container mx-auto px-4" data-id="element-1629">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-16" data-id="element-1630">
            <div className="inline-flex items-center gap-2 bg-orange-100 text-orange-600 px-4 py-1 rounded-full font-bold mb-4" data-id="element-1631">
              <Flame className="w-5 h-5" data-id="element-1632" />
              <span data-id="element-1633">FOMO ALERT</span>
            </div>
            <h2 className="text-4xl md:text-6xl font-black text-gray-900 mb-6" data-id="element-1634">
              למה אסור לפספס?
            </h2>
          </motion.div>

          <div className="max-w-5xl mx-auto" data-id="element-1635">
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-white rounded-3xl p-8 md:p-12 shadow-xl border border-orange-100" data-id="element-1636">
              <ul className="space-y-4" data-id="element-1637">
                {reasons.map((reason, index) => <motion.li key={index} initial={{
                opacity: 0,
                x: -30
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: index * 0.1
              }} className="flex items-start gap-4" data-id="element-1638">
                    <div className="bg-orange-100 rounded-full p-1 shrink-0 mt-1" data-id="element-1639">
                      <CheckCircle2 className="w-5 h-5 text-orange-600" data-id="element-1640" />
                    </div>
                    <div data-id="element-1641">
                      <h3 className="text-xl font-bold text-gray-900 mb-1" data-id="element-1642">
                        {reason.title}
                      </h3>
                      <p className="text-gray-600" data-id="element-1643">{reason.description}</p>
                    </div>
                  </motion.li>)}
              </ul>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Accommodation */}
      <section className="py-24 bg-gradient-to-br from-blue-50 to-cyan-50" data-id="element-1644">
        <div className="container mx-auto px-4" data-id="element-1645">
          <div className="max-w-5xl mx-auto" data-id="element-1646">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-center mb-12" data-id="element-1647">
              <div className="inline-flex items-center gap-2 bg-blue-100 text-blue-600 px-4 py-2 rounded-full font-bold mb-4" data-id="element-1648">
                <Calendar className="w-5 h-5" data-id="element-1649" />
                <span data-id="element-1650">לוח זמנים</span>
              </div>
              <h2 className="text-4xl md:text-5xl font-bold text-[#0A5F8F] mb-4" data-id="element-1651">
                מה לו"ז האירוע?
              </h2>
              <p className="text-xl text-gray-600 mb-8" data-id="element-1652">
                שלושה ימים מלאים בפעילויות, חוויות וקהילה
              </p>
            </motion.div>

            <div className="space-y-8 mb-16" data-id="element-1653">
              {/* Thursday */}
              <motion.div initial={{
              opacity: 0,
              y: 30
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-3xl p-8 shadow-lg border border-blue-100" data-id="element-1654">
                <h3 className="text-3xl font-bold text-[#0A5F8F] mb-6 flex items-center gap-3" data-id="element-1655">
                  <Calendar className="w-8 h-8" data-id="element-1656" />
                  יום חמישי, 9.4.2026
                </h3>
                <div className="space-y-4" data-id="element-1657">
                  {[{
                  time: '14:00 - 15:00',
                  activity: 'הגעה, קבלת חדרים והרשמה'
                }, {
                  time: '15:00 - 16:00',
                  activity: 'מקצה ספרינטים'
                }, {
                  time: '16:30 - 18:00',
                  activity: 'חתירת שקיעה'
                }, {
                  time: '20:00 - 21:00',
                  activity: 'הרצאת השראה'
                }].map((item, index) => <div key={index} className="flex items-start gap-4 bg-white/60 p-4 rounded-xl flex-row-reverse" data-id="element-1658">
                      <div className="bg-blue-600 text-white px-4 py-2 rounded-lg font-bold text-sm whitespace-nowrap shrink-0" data-id="element-1659">
                        {item.time}
                      </div>
                      <div className="text-gray-800 font-medium pt-2 text-right" data-id="element-1660">
                        {item.activity}
                      </div>
                    </div>)}
                </div>
              </motion.div>

              {/* Friday */}
              <motion.div initial={{
              opacity: 0,
              y: 30
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.1
            }} className="bg-gradient-to-br from-cyan-50 to-teal-50 rounded-3xl p-8 shadow-lg border border-cyan-100" data-id="element-1661">
                <h3 className="text-3xl font-bold text-[#0A5F8F] mb-6 flex items-center gap-3" data-id="element-1662">
                  <Calendar className="w-8 h-8" data-id="element-1663" />
                  יום שישי, 10.4.2026
                </h3>
                <div className="space-y-4" data-id="element-1664">
                  {[{
                  time: '7:00 - 7:45',
                  activity: 'יוגהלאטיס על סאפ'
                }, {
                  time: '8:00 - 9:00',
                  activity: 'מקצה טכני תחרותי'
                }, {
                  time: '9:00 - 11:00',
                  activity: 'יציאה לשני מסלולי חתירה חוויתיים לבחירה: מסלול מעגלי בדרום הכנרת - כ-10 ק"מ, ירדנית - 3 ק"מ'
                }, {
                  time: '11:00',
                  activity: 'פתיחת מתחם אקספו - הדגמות, התנסויות, מוסיקה ופינוקים'
                }, {
                  time: '11:30 - 13:30',
                  activity: 'סדנת חתירה למתחילים | סדנת טכניקה למתקדמים | סדנת אקרויוגה'
                }, {
                  time: '14:00 - 16:00',
                  activity: 'סדנת תיקונים עם זזיק | מבוא לגלישת ווינג'
                }, {
                  time: '17:00 - 19:00',
                  activity: 'מסיבת חוף עם DJ'
                }].map((item, index) => <div key={index} className="flex items-start gap-4 bg-white/60 p-4 rounded-xl flex-row-reverse" data-id="element-1665">
                      <div className="bg-cyan-600 text-white px-4 py-2 rounded-lg font-bold text-sm whitespace-nowrap shrink-0" data-id="element-1666">
                        {item.time}
                      </div>
                      <div className="text-gray-800 font-medium pt-2 text-right" data-id="element-1667">
                        {item.activity}
                      </div>
                    </div>)}
                </div>
              </motion.div>

              {/* Saturday */}
              <motion.div initial={{
              opacity: 0,
              y: 30
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.2
            }} className="bg-gradient-to-br from-teal-50 to-emerald-50 rounded-3xl p-8 shadow-lg border border-teal-100" data-id="element-1668">
                <h3 className="text-3xl font-bold text-[#0A5F8F] mb-6 flex items-center gap-3" data-id="element-1669">
                  <Calendar className="w-8 h-8" data-id="element-1670" />
                  יום שבת, 11.4.2026
                </h3>
                <div className="space-y-4" data-id="element-1671">
                  {[{
                  time: '7:00 - 7:45',
                  activity: 'מתיחות ותרגילי כוח על סאפ'
                }, {
                  time: '7:15',
                  activity: 'מסלול תחרותי Long Distance - 10 ק"מ'
                }, {
                  time: '9:00 - 10:30',
                  activity: 'יציאה למסלול חווייתי'
                }, {
                  time: '11:00',
                  activity: 'מקצה מועדונים - מירוץ שליחים'
                }, {
                  time: '12:30',
                  activity: 'פודיום, נשיקות וחיבוקים'
                }].map((item, index) => <div key={index} className="flex items-start gap-4 bg-white/60 p-4 rounded-xl flex-row-reverse" data-id="element-1672">
                      <div className="bg-teal-600 text-white px-4 py-2 rounded-lg font-bold text-sm whitespace-nowrap shrink-0" data-id="element-1673">
                        {item.time}
                      </div>
                      <div className="text-gray-800 font-medium pt-2 text-right" data-id="element-1674">
                        {item.activity}
                      </div>
                    </div>)}
                </div>
              </motion.div>
            </div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-center mb-12" data-id="element-1675">
              <div className="inline-flex items-center gap-2 bg-blue-100 text-blue-600 px-4 py-2 rounded-full font-bold mb-4" data-id="element-1676">
                <MapPin className="w-5 h-5" data-id="element-1677" />
                <span data-id="element-1678">אירוח במקום</span>
              </div>
              <h2 className="text-4xl md:text-5xl font-bold text-[#0A5F8F] mb-4" data-id="element-1679">
                שלושה ימים מלאים? הישארו לישון!
              </h2>
              <p className="text-xl text-gray-600" data-id="element-1680">
                כפר הנופש מעגן מציע אירוח נוח במחירים מיוחדים למשתתפי הפסטיבל
              </p>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-white rounded-3xl p-8 md:p-12 shadow-xl border border-blue-100" data-id="element-1681">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center" data-id="element-1682">
                <div data-id="element-1683">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-1684">
                    למה לישון במקום?
                  </h3>
                  <ul className="space-y-4" data-id="element-1685">
                    {['תתחילו את הבוקר ישר על החוף', 'לא תפספסו אף רגע מהפסטיבל', 'תיהנו ממסיבת הערב עד הסוף', 'מחירים מיוחדים למשתתפי הפסטיבל', 'חדרים נוחים וממוזגים'].map((item, index) => <li key={index} className="flex items-center gap-3" data-id="element-1686">
                        <div className="bg-blue-100 rounded-full p-1" data-id="element-1687">
                          <CheckCircle2 className="w-5 h-5 text-[#0A5F8F]" data-id="element-1688" />
                        </div>
                        <span className="text-gray-700" data-id="element-1689">{item}</span>
                      </li>)}
                  </ul>
                </div>
                <div className="bg-gradient-to-br from-[#0A5F8F] to-[#0D7AB8] rounded-2xl p-8 text-white text-center" data-id="element-1690">
                  <MapPin className="w-12 h-12 mx-auto mb-4" data-id="element-1691" />
                  <h4 className="text-2xl font-bold mb-2" data-id="element-1692">כפר הנופש מעגן</h4>
                  <p className="text-blue-100 mb-6" data-id="element-1693">
                    אירוח איכותי במחירים נוחים
                  </p>
                  <div className="space-y-3" data-id="element-1694">
                    <a href="https://www.maagan.co.il/category/%d7%94%d7%97%d7%93%d7%a8%d7%99%d7%9d/" target="_blank" rel="noopener noreferrer" className="block bg-white/20 hover:bg-white/30 backdrop-blur-sm px-6 py-3 rounded-xl transition-colors border border-white/30" data-id="element-1695">
                      <span className="font-medium" data-id="element-1696">תיאור החדרים</span>
                    </a>
                    <a href="https://www.maagan.co.il/%d7%a9%d7%90%d7%9c%d7%95%d7%aa-%d7%95%d7%aa%d7%a9%d7%95%d7%91%d7%95%d7%aa/uncategorized/" target="_blank" rel="noopener noreferrer" className="block bg-white/20 hover:bg-white/30 backdrop-blur-sm px-6 py-3 rounded-xl transition-colors border border-white/30" data-id="element-1697">
                      <span className="font-medium" data-id="element-1698">
                        מידע נוסף על כפר הנופש
                      </span>
                    </a>
                  </div>
                  <p className="text-sm text-blue-200 mt-4" data-id="element-1699">
                    מספר החדרים מוגבל - הזמינו מוקדם!
                  </p>
                </div>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-center mt-8" data-id="element-1700">
              <Button size="lg" className="bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-600 hover:to-blue-700 text-white px-12 py-6 rounded-full shadow-xl" onClick={() => {
              document.getElementById('pricing-section')?.scrollIntoView({
                behavior: 'smooth'
              });
            }} data-id="element-1701">
                להרשמה המשיכו לגלול למטה ↓
              </Button>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section id="pricing-section" className="py-24 bg-gradient-to-br from-indigo-50 to-purple-50" data-id="element-1702">
        <div className="container mx-auto px-4" data-id="element-1703">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="max-w-6xl mx-auto" data-id="element-1704">
            <div className="text-center mb-12" data-id="element-1705">
              <div className="inline-flex items-center gap-2 bg-indigo-100 text-indigo-600 px-4 py-2 rounded-full font-bold mb-4" data-id="element-1706">
                <CreditCard className="w-5 h-5" data-id="element-1707" />
                <span data-id="element-1708">רכישת כרטיסים</span>
              </div>
              <h2 className="text-4xl md:text-5xl font-bold text-[#0A5F8F] mb-4" data-id="element-1709">
                מחירי הפסטיבל
              </h2>
              <p className="text-xl text-gray-600 mb-8" data-id="element-1710">
                הירשמו עכשיו והבטיחו את מקומכם!
              </p>

              {/* What's Included Section */}
              <motion.div initial={{
              opacity: 0,
              y: 30
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} className="bg-gradient-to-br from-cyan-50 to-blue-50 rounded-3xl p-8 md:p-10 border border-cyan-100 shadow-lg mb-12" data-id="element-1711">
                <div className="flex items-start gap-4" data-id="element-1712">
                  <div className="bg-cyan-500 rounded-full p-3 shrink-0" data-id="element-1713">
                    <Sparkles className="w-6 h-6 text-white" data-id="element-1714" />
                  </div>
                  <div data-id="element-1715">
                    <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-1716">
                      מה כלול במחיר?
                    </h3>
                    <p className="text-lg text-gray-700 leading-relaxed" data-id="element-1717">
                      המחיר כולל השתתפות מלאה ב<strong data-id="element-1718">כ-ל</strong> חוויית
                      הפסטיבל – כל הסדנאות, הרצאות, חתירות, טבילה מרעננת
                      באמבטיית קרח, בירה קרה ועוד הפתעות 🎉
                    </p>
                  </div>
                </div>
              </motion.div>
            </div>

            {/* Companion Toggle Section */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className={`mb-8 rounded-3xl p-6 md:p-8 transition-all shadow-xl ${includeCompanion ? 'bg-gradient-to-br from-emerald-500 via-teal-500 to-cyan-500' : 'bg-white border-2 border-gray-200'}`} data-id="element-1719">
              <div className="flex flex-col md:flex-row items-start gap-6" data-id="element-1720">
                <div className={`rounded-2xl p-4 shrink-0 transition-all ${includeCompanion ? 'bg-white/20 backdrop-blur-sm' : 'bg-gradient-to-br from-emerald-50 to-teal-50'}`} data-id="element-1721">
                  <Users className={`w-8 h-8 ${includeCompanion ? 'text-white' : 'text-emerald-600'}`} data-id="element-1722" />
                </div>

                <div className="flex-1" data-id="element-1723">
                  <h3 className={`text-2xl md:text-3xl font-black mb-2 leading-tight ${includeCompanion ? 'text-white' : 'text-gray-900'}`} data-id="element-1724">
                    באים עם מישהו שלא חותר?
                  </h3>
                  <p className={`text-base md:text-lg mb-5 leading-relaxed font-semibold ${includeCompanion ? 'text-white/90' : 'text-gray-700'}`} data-id="element-1725">
                    הוסיפו כרטיס מלווה ותהנו יחד מהאווירה, המסיבות והפינוקים 🎉
                  </p>

                  {/* What's Included - Always show */}
                  <div className={`rounded-2xl p-4 mb-5 border transition-all ${includeCompanion ? 'bg-white/10 backdrop-blur-md border-white/20' : 'bg-gradient-to-br from-emerald-50 to-teal-50 border-emerald-200'}`} data-id="element-1726">
                    <div className="mb-3" data-id="element-1727">
                      <div className="flex items-center gap-2 mb-1" data-id="element-1728">
                        <Sparkles className={`w-5 h-5 ${includeCompanion ? 'text-white' : 'text-emerald-600'}`} data-id="element-1729" />
                        <span className={`font-bold ${includeCompanion ? 'text-white' : 'text-emerald-900'}`} data-id="element-1730">
                          כלול בכרטיס מלווה:
                        </span>
                      </div>
                      <p className={`text-sm font-semibold pr-7 ${includeCompanion ? 'text-white/90' : 'text-emerald-700'}`} data-id="element-1731">
                        כל חוויות הפסטיבל!
                      </p>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-2.5" data-id="element-1732">
                      <div className={`flex items-center gap-2 text-sm ${includeCompanion ? 'text-white/90' : 'text-emerald-800'}`} data-id="element-1733">
                        <CheckCircle2 className="w-4 h-4 shrink-0" data-id="element-1734" />
                        <span data-id="element-1735">מסיבות ואווירה</span>
                      </div>
                      <div className={`flex items-center gap-2 text-sm ${includeCompanion ? 'text-white/90' : 'text-emerald-800'}`} data-id="element-1736">
                        <CheckCircle2 className="w-4 h-4 shrink-0" data-id="element-1737" />
                        <span data-id="element-1738">סדנאות חוויה</span>
                      </div>
                      <div className={`flex items-center gap-2 text-sm ${includeCompanion ? 'text-white/90' : 'text-emerald-800'}`} data-id="element-1739">
                        <CheckCircle2 className="w-4 h-4 shrink-0" data-id="element-1740" />
                        <span data-id="element-1741">הרצאות השראה</span>
                      </div>
                      <div className={`flex items-center gap-2 text-sm ${includeCompanion ? 'text-white/90' : 'text-emerald-800'}`} data-id="element-1742">
                        <CheckCircle2 className="w-4 h-4 shrink-0" data-id="element-1743" />
                        <span data-id="element-1744">מגוון פינוקים</span>
                      </div>
                      <div className={`flex items-center gap-2 text-sm ${includeCompanion ? 'text-white/90' : 'text-emerald-800'}`} data-id="element-1745">
                        <CheckCircle2 className="w-4 h-4 shrink-0" data-id="element-1746" />
                        <span data-id="element-1747">וגם...</span>
                      </div>
                    </div>
                    <div className={`mt-3 pt-3 border-t ${includeCompanion ? 'border-white/20' : 'border-emerald-200'}`} data-id="element-1748">
                      <div className={`flex items-center gap-2 text-xs ${includeCompanion ? 'text-white/70' : 'text-red-500'}`} data-id="element-1749">
                        <X className="w-3.5 h-3.5 shrink-0" data-id="element-1750" />
                        <span data-id="element-1751">ללא סדנאות מקצועיות ומקצי חתירה</span>
                      </div>
                    </div>
                  </div>

                  <div className="flex flex-col items-center gap-4" data-id="element-1752">
                    <motion.button whileHover={{
                    scale: 1.02
                  }} whileTap={{
                    scale: 0.98
                  }} onClick={() => setIncludeCompanion(!includeCompanion)} className={`relative overflow-hidden w-full max-w-[280px] px-8 py-4 rounded-2xl font-bold text-lg transition-all shadow-lg ${includeCompanion ? 'bg-white text-emerald-600 shadow-white/30' : 'bg-gradient-to-r from-emerald-500 to-teal-500 text-white shadow-emerald-500/40'}`} data-id="element-1753">
                      {showShimmer && !includeCompanion && <motion.div initial={{
                      x: '-100%'
                    }} animate={{
                      x: '200%'
                    }} transition={{
                      duration: 1.5,
                      ease: 'easeInOut'
                    }} className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent" data-id="element-1754" />}
                      <span className="relative z-10 flex items-center justify-center gap-2.5" data-id="element-1755">
                        <Users className="w-5 h-5" data-id="element-1756" />
                        {includeCompanion ? <>
                            <CheckCircle2 className="w-5 h-5" data-id="element-1757" />
                            מלווה נוסף
                          </> : 'הוסף מלווה'}
                      </span>
                    </motion.button>

                    <button onClick={handleCompanionOnlyPurchase} className={`font-medium text-sm md:text-base transition-colors ${includeCompanion ? 'text-white/80 hover:text-white' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-1758">
                      רוצים כרטיס מלווה בלבד ב-₪255?
                    </button>
                  </div>
                </div>
              </div>
            </motion.div>

            {/* Sold Out Banner */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-gradient-to-r from-amber-500 to-orange-500 rounded-2xl p-5 md:p-6 mb-8 shadow-lg border border-amber-400" data-id="element-1759">
              <div className="flex items-start gap-4" data-id="element-1760">
                <div className="bg-white/20 rounded-full p-2 shrink-0" data-id="element-1761">
                  <Flame className="w-6 h-6 text-white" data-id="element-1762" />
                </div>
                <div data-id="element-1763">
                  <h3 className="text-xl md:text-2xl font-black text-white mb-1" data-id="element-1764">
                    🔥 חדרי הבייסיק - SOLD OUT!
                  </h3>
                  <p className="text-white/90 font-semibold text-base md:text-lg" data-id="element-1765">
                    מחיר מיוחד לזוג בחדר פרמיום! הזדרזו לפני שגם אלה נגמרים 🏃
                  </p>
                </div>
              </div>
            </motion.div>

            {/* Premium Rooms Info */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-gradient-to-br from-[#0A5F8F]/5 to-cyan-50 rounded-3xl p-6 md:p-8 mb-8 shadow-lg border border-cyan-200" data-id="element-1766">
              <div className="flex flex-col md:flex-row items-start gap-6" data-id="element-1767">
                <div className="bg-gradient-to-br from-[#0A5F8F] to-cyan-600 rounded-2xl p-4 shrink-0" data-id="element-1768">
                  <Sparkles className="w-8 h-8 text-white" data-id="element-1769" />
                </div>
                <div className="flex-1" data-id="element-1770">
                  <h3 className="text-2xl md:text-3xl font-black text-[#0A5F8F] mb-3" data-id="element-1771">
                    ✨ חדרי פרמיום — לחוויה המושלמת
                  </h3>
                  <p className="text-lg text-gray-700 leading-relaxed mb-5" data-id="element-1772">
                    חדרי הפרמיום ממוקמים{' '}
                    <strong data-id="element-1773">בשורות הראשונות לקו הים</strong> — להתעורר עם נוף
                    ישיר לכנרת!
                  </p>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-1774">
                    {['מבנה אבן מעוצב וצמוד קרקע', 'אבזור עשיר ומפנק', 'מרפסת עם נוף לכנרת', 'מיזוג אוויר ומקלחת מפנקת'].map((feature, index) => <div key={index} className="flex items-center gap-2.5" data-id="element-1775">
                        <div className="bg-cyan-100 rounded-full p-0.5" data-id="element-1776">
                          <CheckCircle2 className="w-4 h-4 text-[#0A5F8F]" data-id="element-1777" />
                        </div>
                        <span className="text-gray-800 font-medium text-sm" data-id="element-1778">
                          {feature}
                        </span>
                      </div>)}
                  </div>
                </div>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-1779">
              {[{
              name: 'חדר פרמיום לזוג - כל הסופ״ש (לאדם)',
              priceDisplay: '1,990',
              price: 1990,
              priceWithCompanionDisplay: '3,730',
              priceWithCompanion: 3730,
              showWithCompanion: true,
              companionParticipant: '1,990',
              companionAddon: '1,740'
            }, {
              name: 'חדר פרמיום ל-3 אנשים - כל הסופ״ש (לאדם)',
              priceDisplay: '1,490',
              price: 1490,
              priceWithCompanionDisplay: '2,730',
              priceWithCompanion: 2730,
              showWithCompanion: true,
              companionParticipant: '1,490',
              companionAddon: '1,240'
            }, {
              name: 'הרשמה לפסטיבל בלבד',
              priceDisplay: '455',
              price: 455,
              priceWithCompanionDisplay: '710',
              priceWithCompanion: 710,
              showWithCompanion: true,
              companionParticipant: '455',
              companionAddon: '255'
            }].filter(item => !includeCompanion || item.showWithCompanion).map((item, index) => <motion.div key={index} initial={{
              opacity: 0,
              scale: 0.9
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.05
            }} whileHover={{
              scale: 1.03,
              y: -5
            }} className={`bg-white rounded-3xl p-6 shadow-lg border transition-all cursor-pointer flex flex-col justify-between h-full relative overflow-hidden group ${selectedTicketName === item.name ? includeCompanion ? 'border-green-500 ring-2 ring-green-500 shadow-xl' : 'border-indigo-500 ring-2 ring-indigo-500 shadow-xl' : includeCompanion ? 'border-green-100 hover:shadow-xl hover:border-green-300' : 'border-indigo-100 hover:shadow-xl hover:border-indigo-300'}`} onClick={() => handleTicketSelect(includeCompanion ? item.priceWithCompanion || item.price : item.price, includeCompanion && item.showWithCompanion ? `${item.name} + כרטיס מלווה` : item.name, includeCompanion ? item.priceWithCompanionDisplay || item.priceDisplay : item.priceDisplay)} data-id="element-1780">
                    <div className={`absolute top-0 right-0 w-24 h-24 rounded-bl-full -mr-4 -mt-4 opacity-50 group-hover:scale-110 transition-transform ${includeCompanion ? 'bg-gradient-to-br from-green-100 to-transparent' : 'bg-gradient-to-br from-indigo-100 to-transparent'}`} data-id="element-1781" />

                    <div className="relative z-10" data-id="element-1782">
                      <h3 className="text-xl font-bold text-gray-900 mb-2 leading-tight min-h-[3.5rem]" data-id="element-1783">
                        {item.name}
                      </h3>

                      {includeCompanion && item.showWithCompanion && <div className="mb-3" data-id="element-1784">
                          <span className="inline-flex items-center gap-1 bg-green-100 text-green-700 px-3 py-1 rounded-full text-sm font-bold" data-id="element-1785">
                            <Users className="w-4 h-4" data-id="element-1786" />+ כרטיס מלווה
                          </span>

                          {/* Price Breakdown */}
                          <div className="mt-3 p-3 bg-green-50 rounded-lg border border-green-100" data-id="element-1787">
                            <div className="text-xs text-gray-600 space-y-1" data-id="element-1788">
                              <div className="flex justify-between items-center" data-id="element-1789">
                                <span data-id="element-1790">משתתף:</span>
                                <span className="font-semibold text-gray-900" data-id="element-1791">
                                  ₪{item.companionParticipant}
                                </span>
                              </div>
                              <div className="flex justify-between items-center" data-id="element-1792">
                                <span data-id="element-1793">מלווה:</span>
                                <span className="font-semibold text-gray-900" data-id="element-1794">
                                  ₪{item.companionAddon}
                                </span>
                              </div>
                              <div className="pt-1 mt-1 border-t border-green-200 flex justify-between items-center font-bold" data-id="element-1795">
                                <span className="text-green-700" data-id="element-1796">סה״כ:</span>
                                <span className="text-green-700" data-id="element-1797">
                                  ₪{item.priceWithCompanionDisplay}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>}

                      <div className="flex flex-col gap-1 mt-auto" data-id="element-1798">
                        <span className={`text-4xl font-black ${includeCompanion ? 'text-green-600' : 'text-indigo-600'}`} data-id="element-1799">
                          ₪
                          {includeCompanion ? item.priceWithCompanionDisplay || item.priceDisplay : item.priceDisplay}
                        </span>
                      </div>
                    </div>

                    <div className={`mt-6 pt-4 border-t border-gray-100 flex items-center justify-between text-sm font-medium ${includeCompanion ? 'text-green-600 group-hover:text-green-700' : 'text-indigo-600 group-hover:text-indigo-700'}`} data-id="element-1800">
                      <span data-id="element-1801">
                        {selectedTicketName === item.name ? 'נבחר' : 'לחצו לתשלום'}
                      </span>
                      <div className={`rounded-full p-1 transition-colors ${selectedTicketName === item.name ? includeCompanion ? 'bg-green-600 text-white' : 'bg-indigo-600 text-white' : includeCompanion ? 'bg-green-50 group-hover:bg-green-100' : 'bg-indigo-50 group-hover:bg-indigo-100'}`} data-id="element-1802">
                        <CheckCircle2 className="w-4 h-4" data-id="element-1803" />
                      </div>
                    </div>
                  </motion.div>)}
            </motion.div>

            {/* Iframe Container for Tranzila Payment */}
            <div className={`w-full bg-white rounded-3xl shadow-2xl overflow-hidden border border-gray-100 transition-all duration-500 ${showIframe ? 'opacity-100 max-h-[700px] mt-12' : 'opacity-0 max-h-0 overflow-hidden'}`} data-id="element-1804">
              <div className="bg-gray-50 p-4 border-b border-gray-100 flex items-center justify-between" data-id="element-1805">
                <div className="flex items-center gap-2 text-gray-600" data-id="element-1806">
                  <Lock className="w-4 h-4" data-id="element-1807" />
                  <span className="text-sm font-medium" data-id="element-1808">
                    תשלום מאובטח באמצעות טרנזילה
                  </span>
                </div>
                <div className="text-sm font-bold text-[#0A5F8F]" data-id="element-1809">
                  {selectedTicketName}
                </div>
              </div>
              <iframe ref={iframeRef} name="tranzila" width="100%" height="600" frameBorder="0" allow="payment" className="w-full" data-id="element-1810"></iframe>
            </div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-center mt-8" data-id="element-1811">
              <Button size="lg" className="bg-gradient-to-r from-indigo-500 to-purple-600 hover:from-indigo-600 hover:to-purple-700 text-white px-12 py-6 rounded-full shadow-xl" onClick={() => {
              document.getElementById('pricing-section')?.scrollIntoView({
                behavior: 'smooth'
              });
            }} data-id="element-1812">
                הרשמה לפסטיבל
              </Button>
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* WhatsApp Group Section */}
      <section className="py-24 bg-gradient-to-br from-green-50 to-emerald-50" data-id="element-1813">
        <div className="container mx-auto px-4" data-id="element-1814">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="max-w-3xl mx-auto text-center" data-id="element-1815">
            <div className="inline-flex items-center gap-2 bg-green-100 text-green-600 px-4 py-2 rounded-full font-bold mb-6" data-id="element-1816">
              <MessageCircle className="w-5 h-5" data-id="element-1817" />
              <span data-id="element-1818">הצטרפו לקהילה</span>
            </div>

            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-1819">
              קבוצת הווטסאפ השקטה של האירוע
            </h2>

            <p className="text-xl text-gray-600 mb-8 leading-relaxed" data-id="element-1820">
              הצטרפו לקבוצת הווטסאפ השקטה שלנו וקבלו עדכונים ראשונים על הפסטיבל,
              מחירים מיוחדים ופרטים חשובים
            </p>

            <motion.div whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} data-id="element-1821">
              <Button size="lg" className="bg-[#25D366] hover:bg-[#20BA5A] text-white text-xl px-12 py-8 rounded-full shadow-2xl shadow-green-500/30 inline-flex items-center gap-3" onClick={() => window.open('https://chat.whatsapp.com/BTCYcMWElUsEX6Ds48mQFA', '_blank')} data-id="element-1822">
                <MessageCircle className="w-6 h-6" data-id="element-1823" />
                הצטרפו לקבוצה
              </Button>
            </motion.div>

            <p className="mt-6 text-sm text-gray-500" data-id="element-1824">
              קבוצה שקטה - רק עדכונים חשובים מהצוות
            </p>
          </motion.div>
        </div>
      </section>

      {/* Sponsors Section */}
      <section className="py-16 bg-white border-t border-gray-100" data-id="element-1825">
        <div className="container mx-auto px-4" data-id="element-1826">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-12" data-id="element-1827">
            <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2" data-id="element-1828">
              תודה לנותני החסות
            </h3>
            <p className="text-lg text-gray-600" data-id="element-1829">שבזכותם כל זה לא היה קורה!</p>
          </motion.div>

          <div className="flex flex-col items-center justify-center gap-8 max-w-4xl mx-auto" data-id="element-1830">
            {/* First Row: Focus and Super Boards */}
            <div className="flex flex-wrap items-center justify-center gap-8 md:gap-12" data-id="element-1831">
              <motion.div initial={{
              opacity: 0,
              scale: 0.9
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.1
            }} className="flex items-center justify-center w-32 h-24 md:w-40 md:h-28" data-id="element-1832">
                <img src="https://cdn.magicpatterns.com/uploads/c9cqmiETssEvaaWTmgei9g/Screenshot_20260114_100258_Adobe_Acrobat~2.jpg" alt="Focus Hawaii" className="max-h-full max-w-full object-contain" data-id="element-1833" />
              </motion.div>

              <motion.div initial={{
              opacity: 0,
              scale: 0.9
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.2
            }} className="flex items-center justify-center w-32 h-24 md:w-40 md:h-28" data-id="element-1834">
                <img src="https://cdn.magicpatterns.com/uploads/mv2v6jUXwPZU392ZcXr96e/tempFileForShare_20260114-101156.jpg" alt="Super Boards" className="max-h-full max-w-full object-contain" data-id="element-1835" />
              </motion.div>
            </div>

            {/* Second Row: Freefull, Yamit, Zazik */}
            <div className="flex flex-wrap items-center justify-center gap-8 md:gap-12" data-id="element-1836">
              <motion.div initial={{
              opacity: 0,
              scale: 0.9
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.3
            }} className="flex items-center justify-center w-32 h-24 md:w-40 md:h-28" data-id="element-1837">
                <img src="https://cdn.magicpatterns.com/uploads/jgUGGBjF8wH9kuTWb95A31/IMG-20240320-WA0021.jpg" alt="Freefull Sea Sports" className="max-h-full max-w-full object-contain" data-id="element-1838" />
              </motion.div>

              <motion.div initial={{
              opacity: 0,
              scale: 0.9
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.4
            }} className="flex items-center justify-center w-32 h-24 md:w-40 md:h-28" data-id="element-1839">
                <img src="https://cdn.magicpatterns.com/uploads/2GpMhfwu9CXQAfHdGfWn5v/Screenshot_20260114_101728_Photos~2.jpg" alt="Yamit" className="max-h-full max-w-full object-contain" data-id="element-1840" />
              </motion.div>

              <motion.div initial={{
              opacity: 0,
              scale: 0.9
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.5
            }} className="flex items-center justify-center w-32 h-24 md:w-40 md:h-28" data-id="element-1841">
                <img src="https://cdn.magicpatterns.com/uploads/73y5FStqEUKbtd3kEz9SFX/tempFileForShare_20260114-101936.jpg" alt="Zazik" className="max-h-full max-w-full object-contain" data-id="element-1842" />
              </motion.div>

              <motion.div initial={{
              opacity: 0,
              scale: 0.9
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.6
            }} className="flex items-center justify-center w-32 h-24 md:w-40 md:h-28" data-id="element-1843">
                <img src="https://cdn.magicpatterns.com/uploads/npk7YuYBA3fqzgJiMFKPp9/sk_logo_01.jpg" alt="SK Surf Boards" className="max-h-full max-w-full object-contain" data-id="element-1844" />
              </motion.div>
            </div>
          </div>
        </div>
      </section>

      <Footer data-id="element-1845" />
      <WaterTribeFestTicketSelection isOpen={isFormOpen} onClose={() => setIsFormOpen(false)} data-id="element-1846" />
      <WaterTribeFestPrePaymentForm isOpen={showPrePaymentForm} onClose={() => setShowPrePaymentForm(false)} onSubmit={handlePrePaymentFormSubmit} ticketName={pendingTicket?.name || ''} ticketPrice={pendingTicket?.priceDisplay || ''} ticketType={pendingTicket?.ticketType} data-id="element-1847" />
    </div>;
}